import { createRichTextFromNodes } from './createRichTextFromNodes';
/**
 * Create empty rich text value
 */
export function createRichText(initialText = '') {
    return createRichTextFromNodes([
        { type: 'paragraph', children: [{ type: 'text', text: initialText }] },
    ]);
}
